import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import parse from "html-react-parser";

export const Announcements = (announcementInfo) => {

  const [annVals, setAnnVals] = useState(" ");
  useEffect(() => {
    if (announcementInfo) {
      setAnnVals(Object.values(announcementInfo)[0]);
    }
  }, [announcementInfo]);
  
  return (
    <div className="dashboard__content__component">   
        <div style={{paddingTop:"5px"}}>
          <Typography variant="h4" fontWeight={650} paddingBottom={3}>{annVals?.title}</Typography>
          {annVals?.body ? parse(annVals?.body) : " "}    
        </div>
    </div>
  );
};

export default Announcements;
